import { render, staticRenderFns } from "./NetsPayment.vue?vue&type=template&id=7aa21ef8"
import script from "./NetsPayment.vue?vue&type=script&lang=js"
export * from "./NetsPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports